import { InjectionToken } from '@angular/core';
import Clarity from '@microsoft/clarity';

export type ClarityConsentV2Options = {
	ad_Storage: 'granted' | 'denied';
	analytics_Storage: 'granted' | 'denied';
};

export interface ClarityApi {
	init(projectId: string): void;
	consentV2(consentOptions?: ClarityConsentV2Options): void;
}

export const CLARITY_API = new InjectionToken<ClarityApi>('CLARITY_API', {
	providedIn: 'root',
	factory: (): ClarityApi => ({
		init: (projectId: string) => Clarity.init(projectId),
		consentV2: (consentOptions?: ClarityConsentV2Options) =>
			Clarity.consentV2(consentOptions),
	}),
});
